// extracted by mini-css-extract-plugin
export default {"pageWrap":"ub-z","fullWidth":"vb-z","heading":"wb-z","fullBleed":"xb-z","hidden":"yb-z"};